import { Device } from "./Gateways";

export enum NetworkType {
    ROOM = "room",
    ZONE = "zone",
    GROUP = "group",
}

export type NetworkSelected = Device & {
    widgetName?: string;
    color?: string;
    time_series?: string;
}

export type NetworkStatus = {
    networkId: string;
    lastUpdated: string;
	id: string | number;
	name: string;
	type: string;
	status: 0 | 1 | number;
};
